import React, { useMemo } from 'react';

import ProductListing from '../product-listing';

import CategoryListing from '../category-listing';

import type { BrandContentProps } from '..';
import * as S from '../styles';

const FeaturedBrandContent = ({
  id,
  name,
  logo,
  externalUri,
  externalUriText,
  brandLinkClick,
  products,
  categories,
  categoryTree,
  analyticsAccessLink,
}: BrandContentProps) => {
  const brand = useMemo(() => ({ id, name, logo }), [id, name, logo]);
  const titleLogo = useMemo(
    () => <S.Image width={70} alt={name} src={logo!} />, // Many (non-null) assumptions done here...
    [name, logo]
  );

  return (
    <div>
      <S.Header titleLogo={titleLogo} title={name}>
        {analyticsAccessLink && (
          <S.Analytics>{analyticsAccessLink}</S.Analytics>
        )}
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a
          onClick={brandLinkClick}
          target="_BLANK"
          rel="nofollow noopener"
          href={(externalUri || externalUriText)!}
        >
          {externalUriText}
        </a>
      </S.Header>

      <ProductListing products={products} brandName={name} />
      <CategoryListing
        categories={categories}
        categoryTree={categoryTree}
        brand={brand}
      />
    </div>
  );
};

export default FeaturedBrandContent;
